import { createAction } from '@reduxjs/toolkit';

/**
 * Declared apart from the thunk that dispatches it: the thunk pulls in every
 * api slice, and state that clears on logout may sit underneath those slices.
 */
export const logout = createAction('auth/logout');
